import React from 'react';
import NoSelected from "../../Utils/NoSelected";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronRight, faMinus} from "@fortawesome/free-solid-svg-icons";
import {ArrowUturnDownIcon} from "@heroicons/react/16/solid";


function List({
                       list, depth = 0, onChange, state, selectedId, inputData, handleInputEnter,
                        data, expandedMenus, setExpandedMenus, required, recursive,
                        multiSearch, checkedIds, onMultiCheckChange,
                        /** id가 없을 때 name/label로 active 매칭(엑셀 등 특수 케이스) */
                        matchActiveByNameWhenIdMissing = false,
                   }) {

    const toggleSubMenu = (menuId) => {
        setExpandedMenus((prevState) => {
            return {
                ...prevState,
                [menuId]: !prevState[menuId],
            }
        });
    };

    return (
        <ul className={``}>
            {list.length > 0 ? (
                (list.map((item, index) =>
                    <li key={item.id} className={` ${depth ==0 ? `top-parent`:``} `}>
                        <div className={`bg-white compo-each h-[30px] flex ${
                            expandedMenus[item.id] ==true ? 'bg-choice' : index % 2 === 0 ? 'bg-even' : 'bg-odd'
                        }`}
                             style={{ paddingLeft: `${depth * 20}px` }}
                        >
                            {recursive &&
                                (item.children.length > 0 ? (
                                        <FontAwesomeIcon icon={expandedMenus[item.id] ? faChevronDown: faChevronRight }
                                                         onClick={() => toggleSubMenu(item.id)}
                                                         className={`cursor-pointer w-[10px] h-[10px] p-[10px] `}/>
                                    ):(
                                        <FontAwesomeIcon icon={faMinus }
                                                         className={`w-[6px] h-[6px] p-[12px] `}/>
                                    )
                                )
                            }
                            {!recursive && <span className={'inline-block pl-[10px]'}></span>}

                            {multiSearch && (
                                <input
                                    type="checkbox"
                                    className="ml-[4px] mr-[6px]"
                                    checked={checkedIds?.includes(item.id)}
                                    onChange={(e) => onMultiCheckChange?.(item, e.target.checked)}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            )}

                            <button className={`truncate  line-height-30 ${
                                (String(data?.id) === String(item.id))
                                || (
                                    matchActiveByNameWhenIdMissing
                                    && (data?.id == null)
                                    && String(data?.assetName ?? data?.name ?? data?.title ?? "").trim() !== ""
                                    && String(data?.assetName ?? data?.name ?? data?.title ?? "").trim()
                                        === String(item.assetName ?? item.name ?? item.title ?? "").trim()
                                )
                                    ? `selected`
                                    : ``
                            }`}
                                    onClick={() => onChange(item)}>{item.assetName ?? item.name ?? item.title}</button>

                            {state?.state && (
                                <span className="ml-auto pr-[10px] text-[15px] font-bold cursor-pointer" onClick={() => {
                                    selectedId.setSelectedId(item.id);
                                    setExpandedMenus((prevState) => {
                                        return {
                                            ...prevState,
                                            [item.id]: true,
                                        }
                                    });
                                }}>
                                    +
                                </span>
                            )}
                        </div>

                        {state?.state && selectedId?.selectedId === item.id && (
                            <div
                                className="bg-white h-[30px] flex items-center justify-between pr-[5px]"
                            >
                                <input
                                    className="flex-1 line-height-30 border border-[#e5e5e5] h-[30px] text-indent text-[12px] focus:outline-none focus:border-[#6f6ff5]"
                                    placeholder="하위 코드를 입력하세요"
                                    autoFocus
                                    onChange={(e) =>
                                        inputData?.setInputData(prev => ({
                                            ...prev,
                                            sub: e.target.value,
                                        }))
                                    }
                                    onKeyDown={(e) => handleInputEnter(e)}
                                    value={inputData?.inputData?.sub}
                                />

                                <ArrowUturnDownIcon className="ml-1 w-[15px] h-[15px] cursor-pointer rotate-90"
                                                    onClick={() => {
                                                        inputData?.setInputData(null);
                                                        selectedId.setSelectedId(null);
                                                    }}
                                />
                            </div>
                        )}

                        {
                            <>
                                {expandedMenus[item.id] && item.children && item.children.length > 0 &&
                                    (<List list={item.children}
                                                depth={depth + 1}
                                                onChange={onChange}
                                                // name={name===''? item.name :  '... > ' + item.name}
                                                data={data}
                                                expandedMenus={expandedMenus}
                                                setExpandedMenus={setExpandedMenus}
                                                required={required} recursive={recursive}
                                                state={state}
                                                selectedId={selectedId}
                                                inputData={inputData}
                                                handleInputEnter={handleInputEnter}
                                                multiSearch={multiSearch}
                                                checkedIds={checkedIds}
                                                onMultiCheckChange={onMultiCheckChange}
                                                matchActiveByNameWhenIdMissing={matchActiveByNameWhenIdMissing}
                                    />)
                                }
                            </>
                        }
                    </li>
                ))
            ):(
                <>
                    <NoSelected title={"코드를 생성하세요 : 환경설정"} className={"w-[calc(100%-10px)]"} />
                </>
            )
            }

        </ul>
    )
}

export {List}